<template>
  <div class="info-window" v-if="infoWindow.open" >
    <h4>{{ infoWindow.title }}</h4>

    <div class="text">
      <p class="flex"><img class="map" src="/images/location-green.svg" alt=""> <span>{{ infoWindow.address }}</span></p>
      <p class="flex"><img class="phone" src="/images/phone-green.svg" alt=""> <span>{{ infoWindow.phone }}</span></p>
    </div>

    <div class="detail-buttons">
      <!-- <a
        :href="infoWindow.url"
        class="map details"
        :class="{ full: !infoWindow.book_now }"
      > -->
      <a
        :href="infoWindow.url"
        class="map details"
      >
        View Details
      </a>

      <!-- <a v-if="infoWindow.book_now" :href="infoWindow.book_now"> -->
      <a>
          Book Now
      </a>
    </div>

    <ul
      class="list"
      v-if="infoFeaturesShow"
    >
      <li
        v-for="(feature, index) of infoWindow.features"
        :key="index"
      >
        {{ feature }}
      </li>
    </ul>

    <!-- <a
      class="toggle-services"
      @click="infoFeaturesShow = !infoFeaturesShow"
    >
      <span v-if="!infoFeaturesShow">Show Services +</span>
      <span v-else>Hide Services -</span>
    </a> -->

    <!-- <a
      :href="infoWindow.url"
      class="button small light-blue"
    >
      <span class="icon icon-right-arrow-no-bg"></span>
    </a> -->
  </div>
</template>

<script>
  export default {
    props: {
      infoWindow: Object
    },

    data () {
		  return {
        infoFeaturesShow: false
      }
    }
  }
</script>

<style lang="scss">
@import "../../../sass/core/variables.scss";

.info-window {
  position: absolute;
  bottom: 40px;
  left: 7px;
  z-index: 999;

  width: 100%;
  max-width: 355px;

  background: white;
  box-shadow: 0 2px 10px 0 rgba(101,119,129,0.7);

  @media (min-width: $medium) {
    bottom:20px;
    left: 20px;
  }

  h4 {
    width: 100%;
    margin-bottom: 0;
    padding: 23px 16px 0;

    font-family: $font-family-1;
    font-size: 14px;
    font-weight: 600;
    line-height: 18px;
    letter-spacing: -0.2px;
    color: #313232;
  }

  .text {
    display: inline-block;
    width: 100%;
    padding: 8px 16px 20px;

    p {
      align-items: flex-start;
      justify-content: space-between;
      margin: 0 0 4px;

      img.phone {
        width: 13px;
        margin-top: 3px;
      }

      img.map {
        width: 10px;
        margin-top: 3px;
      }

      span {
        width: 303px;

        color: #484A4B;
        font-size: 13px;
        letter-spacing: 0;
        line-height: 20px;
      }
    }
  }

  a.button {
    position: absolute;
    top: 10px;
    right: 10px;

    width: 32px;
    min-width: 32px;
    height: 32px;
    padding: 0;

    border-radius: 0;

    span {
    position: relative;
    top: -3px;

    font-size: 14px;
    }
  }

  ul.list {
    padding: 0 20px 15px 20px;
    margin: 0;

    li {
      position: relative;

      margin: 0 0 5px;
      padding: 0 0 0 30px;

      font-size: 14px;
      font-weight: 500;
      letter-spacing: 0;
      line-height: 20px;
      color: #313232;

      &:before {
        content: "\e97b";
        position: absolute;
        top: 0;
        left: 0;

        font-family: $font-icon;
        font-size: 20px;
        color: $color-2;
      }
    }
  }

  .toggle-services {
    padding: 0 20px;
    font-size: 12.5px;
    color: $color-2;

    cursor: pointer;
    transition: all .4s ease-in-out;

    &:hover {
      color: $grey-4;
    }
  }

  .detail-buttons {
    display: flex;
    height: 38px;

    a {
        flex: 1;
        display: flex;
        justify-content: center;
        background-color: #657781;
        color: #FFFFFF;
        font-size: 13px;
        line-height: 24px;
        padding: 8px 8px 6px 2px;

        font-weight: 500;
        letter-spacing: -0.19px;

        transition: all .4s ease-in-out;
        cursor: pointer;

        &.details {
            background-color: #43B02A;
        }

        &:hover {
            background: $grey-4;
            border-color: $color-4;
            color: white;
        }

        &.full {
            background-color: #657781;

            &:hover {
                background: $grey-4;
                border-color: $color-4;
                color: white;
            }
        }
    }
  }

}
</style>



// WEBPACK FOOTER //
// resources/assets/frontend/js/components/locations/InfoWindow2.vue